import './buttonsLogic';
import './slider';
